// eslint-disable-next-line import/prefer-default-export
export const reverseString = (str) => {
  return str.split('').reverse().join('');
};
